<div class="modal-header">
  <h5 class="modal-title">
    <span class="modal-title-icon is-chat" aria-hidden="true"></span>
    Nueva sala
  </h5>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div class="mb-3">
    <label class="form-label">Usuarios</label>
    <select2 [multiple]="true" [data]="userSelectData" [(ngModel)]="selectedUserIds" placeholder="Selecciona usuarios"></select2>
  </div>

  <div class="mb-3">
    <label class="form-label">Título (opcional)</label>
    <input type="text" class="form-control" [(ngModel)]="title" placeholder="Se usarán los nombres de los usuarios si se deja en blanco" />
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn-outline-black" (click)="close()">Cancelar</button>
  <button type="button" class="btn-lead" [disabled]="selectedUserIds.length === 0 || saving" (click)="create()">
    Crear sala
  </button>
</div>
